import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, PhoneIcon, XIcon, InstagramIcon, FacebookIcon } from 'lucide-react';
import { CONTACT } from '../data/site';
const LINKS = [{
  label: 'Home',
  href: '#home'
}, {
  label: 'Coach',
  href: '#coach'
}, {
  label: 'Programs',
  href: '#programs'
}, {
  label: 'Gallery',
  href: '#gallery'
}, {
  label: 'FAQ',
  href: '#faq'
}];
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const handleAnchor = (event: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    event.preventDefault();
    setOpen(false);
    const target = document.querySelector(href);
    if (target) {
      history.pushState(null, '', href);
      target.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled ? 'bg-black/90 backdrop-blur-md border-b border-ink-line shadow-lg shadow-black/40' : 'bg-gradient-to-b from-black/80 to-transparent'}`} data-id="element-134" data-mp="emrdvs2cucb0">
      <div className="mx-auto max-w-7xl px-4 sm:px-6" data-id="element-135" data-mp="3n3mawqwh12h6">
        <div className="flex h-16 sm:h-20 items-center justify-between gap-4" data-id="element-136" data-mp="3n575ggisclf1">
          <a href="#home" onClick={event => handleAnchor(event, '#home')} className="flex items-center gap-3" data-id="element-137" data-mp="3s38mkvwnianv">
            <img src={CONTACT.logo} alt="Leal 11 Sports logo" className="h-10 w-10 sm:h-12 sm:w-12 rounded-full object-cover ring-1 ring-white/20" data-id="element-138" data-mp="5mmaru47202n" />
            <span className="leading-none" data-id="element-139" data-mp="39bpielqw4qk9">
              <span className="block font-display text-lg sm:text-xl uppercase tracking-wide" data-id="element-140" data-mp="39aeiwy4ha4yy">
                Leal 11 Sports
              </span>
              <span className="block text-[10px] sm:text-[11px] uppercase tracking-[0.22em] text-white/50" data-id="element-141" data-mp="2wcgdug7mmuy4">
                Soccer Academy · NYC
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-8" aria-label="Main" data-id="element-142" data-mp="3629qzlnf3i4h">
            {LINKS.map(link => <a key={link.href} href={link.href} onClick={event => handleAnchor(event, link.href)} className="text-sm font-medium text-white/70 transition-colors hover:text-white" data-id="element-143" data-mp="2ibm49u8uenxv">
                {link.label}
              </a>)}
          </nav>

          <div className="hidden lg:flex items-center gap-4" data-id="element-144" data-mp="2na74hto3h7mb">
            <div className="flex items-center gap-3 border-r border-white/20 pr-4" data-id="element-145" data-mp="7jkxf8ura65a">
              <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="text-white/70 transition-colors hover:text-brand-orange" aria-label="Instagram" data-id="element-146" data-mp="2lsu7ionuxls">
                <InstagramIcon className="h-4 w-4" data-id="element-147" data-mp="f1skg1gspvxb" />
              </a>
              <a href={CONTACT.facebook} target="_blank" rel="noreferrer" className="text-white/70 transition-colors hover:text-brand-orange" aria-label="Facebook" data-id="element-148" data-mp="15fbjgqbv2ug">
                <FacebookIcon className="h-4 w-4" data-id="element-149" data-mp="xu3fj957kpkv" />
              </a>
            </div>
            <a href={`tel:+1${CONTACT.phoneRaw}`} className="flex items-center gap-2 text-sm font-semibold text-white/80 transition-colors hover:text-white" data-id="element-150" data-mp="k2yd5zaghj6u">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-151" data-mp="1bu5xswhfhl0n" />
              {CONTACT.phoneDisplay}
            </a>
            <a href="#register" onClick={event => handleAnchor(event, '#register')} className="rounded-full bg-gradient-to-r from-brand-orange to-brand-red px-5 py-2.5 text-sm font-bold uppercase tracking-wide text-white shadow-lg shadow-brand-red/25 transition-transform hover:scale-[1.03]" data-id="element-152" data-mp="1gle8rwyepefx">
              Claim 20% Off
            </a>
          </div>

          <button type="button" onClick={() => setOpen(value => !value)} className="lg:hidden inline-flex h-10 w-10 items-center justify-center rounded-lg border border-ink-line bg-ink-card text-white" aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-153" data-mp="3b2xqw4qc8ph6">
            {open ? <XIcon className="h-5 w-5" data-id="element-154" data-mp="1uv01xtq8v6h" /> : <MenuIcon className="h-5 w-5" data-id="element-155" data-mp="3u1jqff67i8iz" />}
          </button>
        </div>
      </div>

      <AnimatePresence initial={false} data-id="element-156" data-mp="uda376xquepi">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="lg:hidden overflow-hidden border-t border-ink-line bg-black/95 backdrop-blur" data-id="element-157" data-mp="uetlf32ymztx">
            <nav className="px-4 py-4 space-y-1" aria-label="Mobile" data-id="element-158" data-mp="2hai122q4c590">
              {LINKS.map(link => <a key={link.href} href={link.href} onClick={event => handleAnchor(event, link.href)} className="block rounded-lg px-3 py-3 text-base font-medium text-white/80 transition-colors hover:bg-white/5 hover:text-white" data-id="element-159" data-mp="2m9l4xjud45fe">
                  {link.label}
                </a>)}
              <a href="#register" onClick={event => handleAnchor(event, '#register')} className="mt-2 block rounded-full bg-gradient-to-r from-brand-orange to-brand-red px-5 py-3 text-center text-sm font-bold uppercase tracking-wide text-white" data-id="element-160" data-mp="34zkmzmrsck9b">
                Claim 20% Discount Now
              </a>
              <div className="mt-4 flex items-center justify-center gap-6 border-t border-ink-line pt-5 pb-2" data-id="element-161" data-mp="1eto3yp90ghhf">
                <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="text-white/70 transition-colors hover:text-brand-orange" aria-label="Instagram" data-id="element-162" data-mp="1olk5kaab2pqe">
                  <InstagramIcon className="h-5 w-5" data-id="element-163" data-mp="1xkffnxgh0jyz" />
                </a>
                <a href={CONTACT.facebook} target="_blank" rel="noreferrer" className="text-white/70 transition-colors hover:text-brand-orange" aria-label="Facebook" data-id="element-164" data-mp="1tjvhcqk5vab9">
                  <FacebookIcon className="h-5 w-5" data-id="element-165" data-mp="d5lr1qwczbhs" />
                </a>
              </div>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}